// @flow
import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const sliceName = 'launchDarkly';

type Flag = { id: string, value: any };

const darklyAdapter = createEntityAdapter<Flag>();

const launchDarklySlice = createSlice({
  name: sliceName,
  initialState: darklyAdapter.getInitialState(),
  reducers: {
    setData: (state, action) => {
      darklyAdapter.setAll(state, action.payload);
    }
  }
});

export const { setData } = launchDarklySlice.actions;

export const { selectById } = darklyAdapter.getSelectors(
  (state) => state[sliceName]
);

export default launchDarklySlice;
